import { useMemo, useContext } from 'react';

import RemoteSwitcherPlugin from '@atlassian/remote-module-loader/plugin-switcher';

import { HorizontalNavContext } from '../components/horizontal-nav/horizontal-nav-context';

export const useRemoteSwitcherPlugin = () => {
  const { environment } = useContext(HorizontalNavContext);

  return useMemo(
    () =>
      new RemoteSwitcherPlugin({
        env: environment === 'production' ? 'production' : 'staging',
        variant: 'latest',
      }),
    [environment]
  );
};
